import React, {Component} from 'react';

import Zoom from '@material-ui/core/Zoom';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import './styles/fab.css';


const styles = theme => ({
  fab: {
    color: '#fff',
    position: 'fixed'
  },
  fabMenuItem: {
    color: '#999',
    position: 'fixed',
    backgroundColor: '#fff'
  }
});


class Fab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false
    }
    this.handleOpen=this.handleOpen.bind(this);
    this.handleClose=this.handleClose.bind(this);
  }



  handleOpen() {
    this.setState({openMenu: true})
  }
  handleClose() {
    this.setState({openMenu: false})
  }





  render() {
    const { classes } = this.props;

    let menu = !this.props.menu ? null : this.props.menu.map((item, i) => {
      return (
        <div key={i} className='component-misc-fab-menu-item'>
          <Tooltip title={item.title} placement='left'>
            <Zoom
              in={this.state.openMenu}
              timeout={{
                  enter: 200 + 150*(this.props.menu.length-i),
                  exit: 200 + 150*i
              }}
            >

              <Button
                mini
                variant="fab"
                className={classes.fabMenuItem}
                onClick={() => {
                  item.onClick();
                  this.handleClose();
                }}
              >
                <Icon> {item.icon} </Icon>
              </Button>
            </Zoom>
          </Tooltip>
        </div>
      )
    })

    return (
      <div
        className="component-misc-fab-container"
        onMouseLeave={this.handleClose}
      >

        {menu}

        <div className="component-misc-fab-button">
          <Zoom
            key='primary'
            in={true}
            unmountOnExit
          >
            <Button
              variant="fab"
              className={classes.fab}
              color='primary'
              onClick={this.props.onClick}
              onMouseEnter={this.handleOpen}
            >
              <Icon> {this.state.openMenu ? 'clear' : 'add'} </Icon>
            </Button>
          </Zoom>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Fab);



// WEBPACK FOOTER //
// ./src/components/modules/misc/Fab.js